/** --------------------------------------------------------
 * Author Tien Tran
 * Email tientran0019@gmail.com
 * Phone 0972970075
 *
 * Created: 2024-07-24 23:44:00

 * Last updated on: 2024-07-24 23:44:00
 * Last updated by: Tien Tran
 *------------------------------------------------------- */

"use client";

import React from "react";

import Image from "next/image";

import { Box, Stack, Typography, Radio } from "@mui/material";

import { EventTypeV2 } from "@onair/repositories";

export const TYPE_LIST = [
	{
		value: EventTypeV2.SINGLE,
		label: "Sự kiện đơn",
		icon: require("./images/single-event.png"),
		description: "Diễn ra trong một buổi duy nhất với thời gian cố định.",
	},
	{
		value: EventTypeV2.SESSION,
		label: "Sự kiện chuỗi",
		icon: require("./images/event-session.png"),
		description:
			"Gồm nhiều sự kiện nhỏ trong một chương trình, diễn ra vào các khung giờ khác nhau.",
	},
];

interface PropTypes {
	value: EventTypeV2;
	onChange: (v: EventTypeV2) => void;
	error?: {
		message?: string;
	};
}

export const SelectEventType: React.FC<PropTypes> = (props) => {
	const { value, onChange, error } = props;

	return (
		<Stack spacing={3}>
			<Stack>
				<Stack
					direction="row"
					spacing={3}
					justifyContent="space-between"
					sx={{
						flexWrap: {
							xs: "wrap",
							md: "nowrap",
						},
					}}
				>
					{TYPE_LIST.map((el) => {
						const isSelected = value === el.value;
						return (
							<Box
								key={el.value}
								onClick={() => {
									onChange(el.value);
								}}
								sx={{
									cursor: "pointer",
									p: 2,
									width: {
										xs: "100%",
										md: "50%",
									},
									borderRadius: "20px",
									border: `1px solid ${isSelected ? "rgba(0, 80, 255, 1)" : "rgba(145, 158, 171, 0.20)"}`,
									backgroundColor: isSelected
										? "rgba(0, 80, 255, 0.08)"
										: "#FFFFFF",
								}}
							>
								<Box mb={2}>
									<Box
										display="flex"
										alignItems="center"
										justifyContent="space-between"
									>
										<Image
											className="img"
											src={el.icon}
											alt={el.label}
											width={56}
											height={56}
											quality={100}
										/>
										<Radio checked={isSelected} size="medium" />
									</Box>
								</Box>
								<Typography mb={0.5} fontWeight={700} variant="h6">
									{el.label}
								</Typography>
								<Typography color="text.secondary" variant="body2">
									{el.description}
								</Typography>
							</Box>
						);
					})}
				</Stack>
				<Typography
					sx={{
						fontSize: "0.75rem",
						fontWeight: 400,
						mt: 1,
						mx: 1.5,
					}}
					variant="subtitle2"
					color="error"
				>
					{error?.message}
				</Typography>
			</Stack>
		</Stack>
	);
};
